import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { getSelectableBranches } from "selectors";
import { SelectField } from "./Select";

interface Branch {
  id: string;
  name: string;
}

interface BranchSelectProps {
  label: string;
  name: string;
}

export const BranchSelect: React.FC<BranchSelectProps> = ({ label, name }) => {
  const branches = useSelector(getSelectableBranches) as Branch[];

  const branchSelectOptions = useMemo(
    () =>
      branches.map((branch: Branch) => ({
        value: branch.id,
        label: branch.name,
      })),
    [branches],
  );

  return (
    <SelectField label={label} name={name} options={branchSelectOptions} />
  );
};
